type BillingIconProps = {
  color: string;
};

export const BillingIcon = ({ color }: BillingIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="50"
    height="50"
    viewBox="0 0 50 50"
  >
    <defs>
      <clipPath id="h2nbd1ub0a">
        <path data-name="Rectangle 7250" fill="none" d="M0 0h27v27H0z" />
      </clipPath>
    </defs>
    <path data-name="Rectangle 1165" fill="none" d="M0 0h50v50H0z" />
    <g data-name="Groupe 18873">
      <g
        data-name="Groupe 18872"
        clipPath="url(#h2nbd1ub0a)"
        transform="translate(12 12)"
      >
        <path
          data-name="Tracé 13056"
          d="M295.4 1.25v8.63h-1.088V1.25a.2.2 0 0 0-.2-.2h-9.922V0h9.923a1.272 1.272 0 0 1 1.287 1.25"
          transform="translate(-275.585)"
          fill={color}
        />
        <path
          data-name="Tracé 13057"
          d="M18.73 23.562h1.088v2.316a1.272 1.272 0 0 1-1.289 1.25H1.289A1.272 1.272 0 0 1 0 25.878V6.554a.519.519 0 0 1 .155-.369L6.119.286a.551.551 0 0 1 .932.369v6.08a.536.536 0 0 1-.544.527H2.221V6.208h3.743V1.946L1.088 6.769v19.109a.2.2 0 0 0 .2.2h17.24a.2.2 0 0 0 .2-.2z"
          transform="translate(0 -.128)"
          fill={color}
        />
        <path
          data-name="Tracé 13058"
          d="M490.356 372.071a5.983 5.983 0 1 1 6.17-5.981 6.084 6.084 0 0 1-6.17 5.981m0-10.906a4.928 4.928 0 1 0 5.082 4.926 5.012 5.012 0 0 0-5.082-4.926"
          transform="translate(-469.526 -349.542)"
          fill={color}
        />
        <path
          data-name="Tracé 13059"
          d="M584.643 455.235a.5.5 0 0 1-.524.527h-.664a3 3 0 0 1-2.767-2.132h-.915a.527.527 0 0 1 0-1.055h.716v-.37h-.716a.527.527 0 0 1 0-1.054h.915a3 3 0 0 1 2.767-2.132h.664a.527.527 0 0 1 0 1.054h-.664a1.837 1.837 0 0 0-1.6 1.077h1.045a.527.527 0 0 1 0 1.054h-1.318v.37h1.318a.527.527 0 0 1 0 1.055h-1.036a1.836 1.836 0 0 0 1.6 1.077h.664a.507.507 0 0 1 .524.527"
          transform="translate(-561.709 -435.842)"
          fill={color}
        />
        <path
          data-name="Rectangle 7245"
          transform="translate(3.521 9.353)"
          fill={color}
          d="M0 0h12.776v1.054H0z"
        />
        <path
          data-name="Rectangle 7246"
          transform="translate(3.521 11.955)"
          fill={color}
          d="M0 0h11.063v1.054H0z"
        />
        <path
          data-name="Rectangle 7247"
          transform="translate(3.521 14.557)"
          fill={color}
          d="M0 0h10.444v1.054H0z"
        />
        <path
          data-name="Rectangle 7248"
          transform="translate(3.521 17.16)"
          fill={color}
          d="M0 0h10.444v1.054H0z"
        />
        <path
          data-name="Rectangle 7249"
          transform="translate(3.521 19.762)"
          fill={color}
          d="M0 0h11.063v1.054H0z"
        />
      </g>
    </g>
  </svg>
);
